export { useGatewaysTable } from './useGatewaysTable';
